import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Contacts } from './pages/Contacts';
import { Messages } from './pages/Messages';
import { ReunionPoints } from './pages/ReunionPoints';
import { Resources } from './pages/Resources';
import { Checklist } from './pages/Checklist';
import { MeshNetwork } from './pages/MeshNetwork';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="messages" element={<Messages />} />
            <Route path="reunion" element={<ReunionPoints />} />
            <Route path="resources" element={<Resources />} />
            <Route path="checklist" element={<Checklist />} />
            <Route path="mesh" element={<MeshNetwork />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
